export enum PaymentMethodSelectorMode {
    Default= 0,
    StripeCardForm = 1
}
